import { render, staticRenderFns } from "./ContentGenerator.vue?vue&type=template&id=4bbd92e9&scoped=true"
import script from "./ContentGenerator.vue?vue&type=script&lang=js"
export * from "./ContentGenerator.vue?vue&type=script&lang=js"
import style0 from "./ContentGenerator.vue?vue&type=style&index=0&id=4bbd92e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd92e9",
  null
  
)

export default component.exports